<template>
  <div id="map" :class="mapClass"></div>
  <div class="debug" data-test="debug">
    debugging
    <p><b>debugging project-map.vue:</b></p>
    <p>gps = {{ gps }}</p>
    <p>gpsArr = {{ gpsArr }}</p>
    <p data-test="picking">picking = {{ picking }}</p>
    <p>mapKey = {{ mapKey }}</p>
    <p>nearestSites[0] = {{ nearestSites[0] }}</p>
    <p>nearestProjects[0] = {{ nearestProjects[0] }}</p>
    <!--p>currentProject.projectInfo.streetAddress = {{ currentProject.projectInfo.streetAddress }}</p-->
   
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed, watch, onBeforeMount, onUnmounted } from 'vue'
import '../../node_modules/leaflet/dist/leaflet.css'
//import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
import L from 'leaflet'

const DOMAIN = 'https://smp.midspan.work';
//const DOMAIN = 'http://localhost:8080';
const mapClass = computed(() => {
  return props.picking ? 'picking' : ''
})
/*
const props = defineProps<{
  gps: Object,
  popupStr: String,
  //climaticStr: String
  nearestSites: Array<Object>,
  picking: boolean,
  mapKey : number,
}>()*/

const props = defineProps({
  //gps: { type: Object},
  popupStr: { type: String },
  nearestSites: { type: Array<Object>},
  nearestProjects: { type: Array<Object>},
  picking : { type: Boolean},
  mapKey : { type: Number }
})

const gps = defineModel<Object>('gps', { required: true });

//return array from json
const gpsArr = computed(() => {
  return [props.gps.lat, props.gps.lon]
})
const zoom = defineModel<Number>('zoom', { required: true })
//custom icon
const redFlag = L.icon({
  iconUrl: '/red-flag-solid.svg',
  iconSize: [24, 24],
  iconAnchor: [0, 24],
  popupAnchor: [0, -24],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

const greenFlag = L.icon({
  iconUrl: '/green-flag-solid.svg',
  iconSize: [24, 24],
  iconAnchor: [0, 24],
  popupAnchor: [0, -24],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

const blueFlag = L.icon({
  iconUrl: '/blue-flag-solid.svg',
  iconSize: [24, 24],
  iconAnchor: [0, 24],
  popupAnchor: [0, -24],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null
})

let map
let marker
//for some reason prop is not reactive, need to make a reactive copy to watch
const mapKeyWatcher = computed(()=>{
  return props.mapKey;
})

/**
 * watch the mapKey to make map redraw
 */
watch(mapKeyWatcher,()=>{
  console.log("Project-map mapKey changed in watch...");
  //refreshMap();
   if(!map || map===null){
    try{
      initMap();
    }catch(error){
      console.error("..trapped error on mapKey watch.. " + error);
      //refreshMap();
    }

    }else{
      refreshMap();
  }
})

/**
 * try to destroy map when component is unmounted
 */
onUnmounted(()=>{
  console.log("Project-map unmounted...");
  console.log("..map = " + map);
  try{
    map.off();
    map.remove();
  }catch(err){
    console.error("...error removing map, maybe doesnt exist? : " + err)
  }
  //if(map){
 //   map.remove();
 // }
})

//watch(gps, ()=>{
onMounted(() => {
  console.log("Project-map mounted...");
  console.log("..map = " + map);
  try{
    refreshMap();
  }catch(err){
    console.error("..error refreshing map:" + err)
  }
  /*
  //const mapDiv = document.getElementById('map');
  //console.log("..mapDiv = " + mapDiv);
  if(!map || map===null){
    try{
      initMap();
    }catch(error){
      console.log("..error initMap.. " + error);
      //refreshMap();
    }

      //console.log("..map already exists, using map.off() and map.remove()")
      //map.refreshMap();
      //map = map.off();
      //map = map.remove();
    }else{
      refreshMap();
  }*/
});

function refreshMap(){
  console.log("Project-map.refreshMap()...");
  if(map){
    console.log('..map exists, attempting to remove before initMap...');
    map.off();
    map.remove();
  }
  initMap();
  
}
  
/**
 * initialize the map, as per leaflet documentation
 */
function initMap(){
  console.log("Project-map.initMap()...");
    map = L.map('map', { scrollWheelZoom: false, preferCanvas: true }).setView(gpsArr.value, zoom.value)

    /*  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(map);*/

    //add marker
    //let marker = L.marker(gpsArr.value).addTo(map);
    marker = L.marker(gpsArr.value, { icon: greenFlag }).addTo(map)

    //add popup to marker
    marker.bindPopup(props.popupStr).openPopup()
    // let siteGroup = L.layerGroup([marker]).addTo(map);

    //add nearest climatic site markers

    let climaticArr = []
    props.nearestSites.forEach((element) => {
      //console.log("..printing nearest sites element: " + JSON.stringify(element))
      //let climaticMarker = L.marker([element.gps.lat, element.gps.lon])
      
      let climaticMarker = L.circle([element.gps.lat, element.gps.lon], {
        color: 'red',
        fillColor: '#f03',
        fillOpacity: 0.5,
        radius: 3000
      })//.addTo(map);

      //add popup to markers
      climaticMarker.bindPopup(element['lookup'])
      climaticArr.push(climaticMarker)
    })
    let climaticGroup = L.layerGroup(climaticArr).addTo(map)

    //add all projects
    //console.log('first project debug: ' + JSON.stringify(projects[0]))
    // let temp = projects.slice(0,100);
    let projectsArr = []
    props.nearestProjects.forEach((proj) => {
      let projMarker = proj.gps
        ? L.marker([proj.gps['lat'], proj.gps['lon']], { icon: blueFlag })
        : [-1, -1]
      //projMarker.bindPopup(`<b>${proj.id}</b><br>${proj.projectName}`)
      projMarker.bindPopup(
        `<b>${proj.id}</b><br><a href="${DOMAIN}/projects/${proj.id}/details">${proj.name}</a>`
      )
      projectsArr.push(projMarker)
    })
    let allProjectsGroup = L.layerGroup(projectsArr).addTo(map)

    //add layer group controller
    //let layerControl = L.control();
    //layerControl.addOverlay(climaticGroup, "Climatic").addTo(map);

    let osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map)

    let openTopoMap = L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png', {
      maxZoom: 15,
      attribution:
        'Map data: © OpenStreetMap contributors, SRTM | Map style: © OpenTopoMap (CC-BY-SA)'
    })

    let baseLayers = {
      // "Mapbox": mapbox,
      OpenStreetMap: osm,
      OpenTopoMap: openTopoMap
    }

    let overlays = {
      // "Marker": marker,
      Climatic: climaticGroup,
      '100 Nearest Projects:': allProjectsGroup
    }
    let layerControl = L.control.layers(baseLayers, overlays).addTo(map)

    //let map = L.map('map', { layers: climaticGroup, scrollWheelZoom: false }).setView(gpsArr.value, zoom.value);

    //add a popup to display lat, lon on map click
    // let clickPopup = L.popup();
    //listen for click events when 'picking' prop is set true
    if (props.picking) {
      map.on('click', onMapClick)
      marker.on('move', onMarkerMove)
    }

    map.on('zoomend', onZoomChanged)
  //} catch (error) {
  //  console.log("Project-map error on initializing leaflet map")
  //  console.log(error)
  //}
}


//event fire on map point clicked
const emits = defineEmits(['mapClicked'])

//TODO add new marker where clicked
function onMapClick(e) {
  console.log(e)
  console.log('You clicked the map at ' + e.latlng.toString())
  marker.setLatLng(e.latlng).openPopup()
  emits('mapClicked', e.latlng)
}

//called when marker is moved
function onMarkerMove(e) {
  console.log('..marker moved..')
  console.log(e)
  //const mapId = e.target().container()
  let oldMarker = L.marker(e.oldLatLng, { icon: redFlag }).bindPopup(props.popupStr).addTo(map)
}

//called when zoom is changed, to keep in sync when rerendering map
function onZoomChanged(e) {
  //console.log("..zoom changed");
  //console.log(e);
  console.log('new map zoom level = ' + e.target._zoom)
  zoom.value = e.target._zoom
}
</script>

<style lang="css" scoped>
#map {
  height: 600px;
  display: block;
  border: 1px solid var(--blue);
  border-radius: 0.5rem;
  padding: 1rem;
}

.picking:hover {
  cursor: pointer;
}

#map.picking {
  border: 3px dashed var(--blue);
}

.filter-green {
  filter: invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%);
}

/*
.debug{
  color: red;
}*/
</style>
